import { styled } from '@styledComponents';
import { themeSpace, themeMediaQuery, themeColor } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { Button } from '@components/Button';

export const StyledSection = styled(Box)`
  height: 90vh;
  position: relative;
  z-index: 1;
  contain: strict;
  width: 100%;
  ${themeMediaQuery('sm')} {
    min-height: var(--hero-min-height);
  }
`;

export const HeroVideoContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
`;

export const HeroBodymovinWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const HeroVideoWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transform-origin: center center;
  overflow: hidden;
  > video {
    width: 100vw;
    height: 96vh;
    object-fit: cover;
    position: absolute;
    left: 0;
    ${themeMediaQuery('sm')} {
      min-height: var(--hero-min-height);
    }
    ${themeMediaQuery('below_sm')} {
      max-height: 86vh;
    }
  }
`;

export const HeroVideoOverlay = styled.span`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  background-color: #000;
  z-index: 3;
  opacity: 0.5;
`;

export const HeroTextPairing = styled(TextPairing)`
  .text-pairing-eyebrow {
    text-align: center;
  }
`;

export const RegistryHeroTextColumn = styled(Columns)`
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 1;
  justify-content: center;
  display: flex;
  padding: 0;
`;

export const StyledButton = styled(Button)`
  ${themeMediaQuery('below_sm')} {
    padding: 0 15px;
    height: 45px;
    line-height: 43px;
  }
`;

export const StyledGetStartedButton = styled(StyledButton)`
  color: ${themeColor('neutra6')};
  border-color: white;
  &:hover {
    border-color: white;
  }
`;

export const ButtonsContainer = styled(Flex)`
  justify-content: center;
  gap: ${themeSpace(6)} ${themeSpace(8)};
  ${themeMediaQuery('below_sm')} {
    width: 170px;
    flex-direction: column;
  }
`;
